import React from 'react'
import PropTypes from 'prop-types'
import { Button as btn } from '../../components'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import { H1, H2 } from '../../components/Typography'
import { rem } from '../../styles/Mixins'
import HomePageHeaderMask from '../../assets/svgs/petal_mask_homepage.svg'
import { withNullErrorBoundary } from '../../utils/withNullErrorBoundary'
import BackgroundImage from 'gatsby-background-image-es5'

const SliderItem = styled.div`
  align-items: center;
  transform: translateX(0) !important;

  ${media.lg`
    display: flex;
  `}
`

const BannerImageWrapper = styled.div`
  flex: 0 0 100%;
  margin-bottom: ${rem(2)};
  padding-right: ${rem(10)};

  ${media.lg`
    /* flex: 0 0 53.5%; */
    flex: none;
    width: 53.5%;
  `}
`

const ImageInnerWrp = styled.div`
  position: relative;
  top: 0;
  left: -136px;
  width: 137%;
  background-color: #f2f3f7;

  @media (min-width: 400px) {
    left: -145px;
    width: 130%;
  }

  @media (min-width: 500px) {
    left: -200px;
  }

  ${media.sm`
    width: 115%;
    left: -136px;
  `}

  ${media.md`
    width: 115%;
    left: -190px;
  `}

  ${media.lg`
    width: 128%;
    left: -155px;
  `}

  ${media.xl`
    width: 128%;
    left: -200px;
  `}

  ${media.xxl`
    width: 125%;
    left: -230px;
  `}

  @media (min-width: 1920px) {
    width: 136%;
    left: -355px;
  }
`

const ImageWrp = styled(BackgroundImage)`
  display: block;
  box-shadow: inset 1px -1px 1px 2px #fff;
  background-size: cover;
  background-position: center;
  line-height: 0;

  ${media.sm`
    height: initial;
  `}

  @media (min-width: 2600px) {
    :after {
      content: '';
      position: absolute;
      top: 0;
      left: -2px;
      width: 10px;
      height: 100%;
      background-color: #fff;
      z-index: 2;
    }
  }

  img {
    width: 100%;
    border-left: 2px solid #fff;
    border-bottom: 1px solid #fff;
    box-shadow: 0 4px 2px -2px #fff;
    position: relative;
    right: -1px;
    bottom: -2px;

    @media (min-width: 500px) {
      right: -2px;
    }

    ${media.xl`
      right: -3px;
    `}
  }
`

const BannerContentWrapper = styled.div`
  flex: 0 0 100%;
  color: ${(props) => props.theme.colors.primary};
  padding: 0 40px;

  ${media.lg`
    /* flex: 0 0 46.5%; */
    flex: none;
    width: 46.5%;
    margin-top: -70px;
    padding: 0 40px 0 55px;
  `}

  ${media.xl`
    padding: 0 140px 0 55px;
    margin-top: -70px;
  `}

  ${media.xxl`
    margin-top: -90px;
  `}

  @media(min-width: 1920px){
    margin-top: -130px;
  }

  h1 {
    margin-bottom: 0;
  }
`

const BannerSubContent = styled.div`
  font-family: 'foco_cc_bold_italic', sans-serif;
  font-size: ${rem(16)};
  line-height: ${rem(26)};

  p {
    margin: 0;
  }

  ${media.xl`
    font-size: ${rem(26, 'xxxl')};
    line-height: ${rem(45, 'xxxl')};
  `}
`

const Button = styled(btn)`
  margin-top: ${rem(18)};

  ${media.lg`
    margin-top: ${rem(35, 'xxxl')};
  `}

  ${media.xl`
    margin-top: ${rem(35, 'xxxl')};
  `}
`

const H1Mimic = styled(H2)`
  font-size: ${rem(32)};
  font-family: 'foco_cc_black', sans-serif;
  margin: 0;
  margin-bottom: ${rem(18)};
  line-height: ${rem(38)};
  color: ${(props) => props.theme.colors.primary};

  :after {
    content: '.';
    color: ${(props) => props.theme.colors.secondary_dark};
    display: inline-block;
    border-radius: 50%;
    font-size: ${rem(32)};

    ${media.xl`
      font-size: ${rem(52, 'xxxl')};
    `}
  }

  ${media.xl`
      font-size: ${rem(52, 'xxxl')};
      line-height: ${rem(60, 'xxxl')};
  `}

  span {
    color: ${(props) => props.theme.colors.secondary_dark};
  }
`

const HeroSlide = ({
  imgSrc,
  topContent,
  bottomContent,
  title,
  button,
  index,
}) => {
  return (
    <SliderItem className="slide">
      <BannerImageWrapper>
        <ImageInnerWrp>
          <ImageWrp fluid={imgSrc} loading="eager">
            <img src={HomePageHeaderMask} alt={title} />
          </ImageWrp>
        </ImageInnerWrp>
      </BannerImageWrapper>
      <BannerContentWrapper>
        <BannerSubContent
          dangerouslySetInnerHTML={{ __html: topContent }}
        ></BannerSubContent>
        {index === 0 ? (
          <H1 dangerouslySetInnerHTML={{ __html: title }}></H1>
        ) : (
          <H1Mimic dangerouslySetInnerHTML={{ __html: title }}></H1Mimic>
        )}
        <BannerSubContent
          dangerouslySetInnerHTML={{ __html: bottomContent }}
        ></BannerSubContent>
        {button && button.text && button.url ? (
          <Button tab={button.tab} tabIndex="-1" href={button.url}>
            {button.text}
          </Button>
        ) : null}
      </BannerContentWrapper>
    </SliderItem>
  )
}

HeroSlide.propTypes = {
  index: PropTypes.number.isRequired,
  imgSrc: PropTypes.shape({
    aspectRatio: PropTypes.number,
    src: PropTypes.string
  }),
  topContent: PropTypes.string,
  bottomContent: PropTypes.string,
  title: PropTypes.string.isRequired,
  button: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
    tab: PropTypes.string,
  }),
}

export default withNullErrorBoundary(HeroSlide)
